// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import ProjectEditScreen from "../../../src/screens/projects/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} ProjectEditRouteProps */

/** @typedef {Record<string, never>} ProjectEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<ProjectEditRouteProps, ProjectEditRouteState>}
 */
class ProjectEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit project")}</ScreenTitle>
        <ProjectEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<ProjectEditRouteProps>} */
const ProjectEditRouteComponent = memo(shapeComponent(ProjectEditRoute))

export default ProjectEditRouteComponent
